export default { sha: '1c665f67f51149fc22d11e4fdcf22ab64c6d0762', buildNumber: 'undefined' }
